import { useCallback, useEffect, useRef, useState } from "react";

// eslint-disable-next-line  @typescript-eslint/no-unnecessary-type-constraint
export const Load = <T extends unknown>(props: {
  load: () => Promise<T>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extra?: any;
  children: (data: T | null, isLoading: boolean, error: Error | null) => JSX.Element | null;
  onError?: (error: Error) => void;
}) => {
  const { load, extra, children, onError } = props;

  const [data, setData] = useState(null as T | null);
  const [error, setError] = useState(null as Error | null);
  const [isLoading, setIsLoading] = useState(false);

  const mountedRef = useRef(true);

  const initData = useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await load();
      if (!mountedRef.current) {
        return;
      }
      setData(result);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      console.error(e);
      onError?.(e);
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, [extra, load]);

  useEffect(() => {
    mountedRef.current = true;
    initData();

    return () => {
      mountedRef.current = false;
    };
  }, [initData]);

  return children(data, isLoading, error);
};
